import { roundsInfoStore } from "../../../store";
import { interpolation } from "../../../helpers/gameCanvasHelper";
import { updateRoundResultsInLiveBets } from "../../../conatiners";

const growChart = (fps) => {
  const {
    animatingPoints,
    presentPoint,
    chartPoints,
    concentrationDiff,
    shiftAnimationPoint,
    setPresentPoint,
    growChartBy
  } = roundsInfoStore;

  if (presentPoint.diff >= 20) {
    shiftAnimationPoint();
  } else {
    const growingStep = 60/fps * 0.5;
    growChartBy(growingStep);
    const lastPoint = chartPoints[chartPoints.length - 1];
    const futurePoint = animatingPoints[0];
    const pointsDiff = futurePoint - lastPoint;
    const growCoefficient = presentPoint.diff / 20;
    const newPresentPoint = {...presentPoint};

    newPresentPoint.y = lastPoint + pointsDiff * growCoefficient;
    newPresentPoint.point = Math.floor((newPresentPoint.y + concentrationDiff) / 10);
    setPresentPoint(newPresentPoint);
  }
}

const chartVerticalInterpolation = (fps) => {
  const {presentPoint, concentrationPoint, setConcentrationPoint} = roundsInfoStore;
  let ALPHA = 0;
  const alphaGrowingStep = 60/fps * 0.05;

  const doVerticalInterpolation = () => {
    if (ALPHA >= 1) {
          return;
    }
    ALPHA += alphaGrowingStep;
    setConcentrationPoint(interpolation(concentrationPoint, presentPoint.point, ALPHA));
    requestAnimationFrame(doVerticalInterpolation);
  }

  doVerticalInterpolation();
}


const chartAnimation = (fps) => {
  const {animatingPoints, shiftRound} = roundsInfoStore;
  if (animatingPoints.length) {
    growChart(fps);
    if(!animatingPoints.length){
      //it's main round finished
      shiftRound();
      updateRoundResultsInLiveBets();
      roundsInfoStore.checkWiningBet();
      chartVerticalInterpolation(fps);
    }
  }
}

export { chartAnimation }



